import {Subject} from 'rxjs';

import {Languages} from '../enums/languages';

export class LocalisationEventsEmitter {
    private readonly languageChanged: Subject<Languages> = new Subject();

    languageChanged$ = this.languageChanged.asObservable();

    broadcastLanguageChanged(language: Languages) {
        this.languageChanged.next(language);
    }
}
